import { render } from "./TribeSelection.vue?vue&type=template&id=00762087"
import script from "./TribeSelection.vue?vue&type=script&lang=js"
export * from "./TribeSelection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/TribeSelection.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "00762087"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('00762087', __exports__)) {
    api.reload('00762087', __exports__)
  }
  
  module.hot.accept("./TribeSelection.vue?vue&type=template&id=00762087", () => {
    api.rerender('00762087', render)
  })

}


export default __exports__